import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  const nav = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="bg-[#2A3E5C] text-[#FAF4F1]">
      <div className="container-wide py-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src="/images/logo.png" alt="Himalayan Cafe" className="h-12 w-12 rounded-full bg-white p-1" />
            <span className="font-serif-display text-xl">Himalayan Cafe</span>
          </div>
          <p className="text-sm text-[#FAF4F1]/70 leading-relaxed">
            A welcoming local cafe in Letterkenny. Freshly prepared food, quality coffee and a warm atmosphere — for everyone.
          </p>
        </div>

        <div>
          <h5 className="text-sm uppercase tracking-[0.2em] text-[#E05947] mb-4 font-semibold">Quick Links</h5>
          <ul className="space-y-2 text-sm">
            {["about", "menu", "gallery", "reviews", "contact"].map((id) => (
              <li key={id}>
                <button onClick={() => nav(id)} data-testid={`footer-link-${id}`} className="hover:text-[#E05947] transition-colors capitalize">
                  {id}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h5 className="text-sm uppercase tracking-[0.2em] text-[#E05947] mb-4 font-semibold">Find us</h5>
          <ul className="space-y-3 text-sm text-[#FAF4F1]/80">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 shrink-0 text-[#E05947]"/> Church Lane, Letterkenny, Co. Donegal</li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-[#E05947]"/> <a href="tel:+35374920 4400" className="hover:text-[#E05947]">074 920 44 00</a></li>
            <li className="flex items-center gap-2"><Mail size={16} className="text-[#E05947]"/> <a href="mailto:himalayancafelk@gmail.com" className="hover:text-[#E05947]">himalayancafelk@gmail.com</a></li>
          </ul>
        </div>

        <div>
          <h5 className="text-sm uppercase tracking-[0.2em] text-[#E05947] mb-4 font-semibold">Follow</h5>
          <div className="flex gap-3">
            <a href="https://www.instagram.com/himalayancafelk/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#E05947] flex items-center justify-center transition-colors"><Instagram size={16}/></a>
            <a href="https://www.facebook.com/profile.php?id=100090068358508&locale=uk_UA" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#E05947] flex items-center justify-center transition-colors"><Facebook size={16}/></a>
            <a href="https://www.tiktok.com/@himalayan.cafe.le" target="_blank" rel="noopener noreferrer" aria-label="TikTok" data-testid="footer-tiktok" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#E05947] flex items-center justify-center transition-colors">
              <svg viewBox="-50 -50 350 350" width="14" height="14" fill="currentColor"><path d="M168.4 51.7c-19.3-13.1-31.6-35.3-31.6-60.3V-14h-45v207c0 24.1-19.6 43.7-43.7 43.7S4.4 217.1 4.4 193s19.6-43.7 43.7-43.7c4 0 7.9.5 11.6 1.6V104c-3.8-.5-7.7-.8-11.6-.8C-1.5 103.2-43 144.7-43 195.6s41.5 92.4 92.4 92.4 92.4-41.5 92.4-92.4V92.5c19.9 13.3 43.7 21.1 69.4 21.1V67.7c-15-.1-29.1-5.2-41.8-16z"/></svg>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-6 text-center text-xs text-[#FAF4F1]/60">
        © {year} Himalayan Cafe · Crafted with care in Letterkenny
      </div>
    </footer>
  );
}
